import React from "react";

/*
 * Main
 */

export const UserIcon = (): React.ReactElement => {
    return (
        <svg aria-hidden="true" data-icon="user" data-prefix="far" role="img" viewBox="0 0 512 512">
            <path
                d="M423.3 291L402.2 285C431.8 243.9 436 202.3 436 180 436 80.6 355.5 0 256 0 156.6 0 76 80.5 76 180c0 22.3 4.2 63.9 33.8 105l-21.1 6C21.3 310.3 0 371.6 0 408.6v25.7C0 477.1 34.9 512 77.7 512h356.6C477.1 512 512 477.1 512 434.3v-25.7c0-36.2-20.7-98.2-88.7-117.6zM256 48c72.9 0 132 59.1 132 132s-59.1 132-132 132-132-59.1-132-132S183.1 48 256 48zm208 386.3c0 16.4-13.3 29.7-29.7 29.7H77.7C61.3 464 48 450.7 48 434.3v-25.7c0-33.2 22-62.3 53.9-71.4l46.1-13.2C162.7 335.1 200.4 360 256 360s93.3-24.9 108-36l46.1 13.2C442 346.3 464 375.4 464 408.6v25.7z"
                fill="currentColor"
            />
        </svg>
    );
};
